export default {
  title: 'Annual contract discount',
  buttons: {
    edit: 'Edit discount',
    save: 'Save discount',
  },
  toasts: {
    invalid_discount: 'The annual contract discount must be between {{min}}% and {{max}}%',
  },
};
